<div class="epicrisis-line" [class.darkened]="!isActive">
    <input class="form-check-input" style="margin: 0;" [(ngModel)]="isActive" type="checkbox" role="switch" [disabled]="readonly" aria-checked="true"/>
    <span *ngIf="label" class="input-label">{{label}}:</span>
    <div class="input-container" [style.width]="bigInput ? '755px' : '240px'">
        <input type="text" class="form-control form-control-sm" style="width: 100%;" [(ngModel)]="value" [readonly]="!isActive || readonly">
    </div>
</div>